function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 12C2.447 12 2 11.552 2 11 2 10.448 2.447 10 3 10 3.553 10 4 10.448 4 11 4 11.552 3.553 12 3 12M6 11C6 9.698 5.161 8.599 4 8.185L4 1C4 .448 3.553 0 3 0 2.447 0 2 .448 2 1L2 8.185C.839 8.599 0 9.698 0 11 0 12.302.839 13.401 2 13.815L2 15C2 15.552 2.447 16 3 16 3.553 16 4 15.552 4 15L4 13.815C5.161 13.401 6 12.302 6 11M9 6C8.447 6 8 5.552 8 5 8 4.448 8.447 4 9 4 9.553 4 10 4.448 10 5 10 5.552 9.553 6 9 6M12 5C12 3.698 11.161 2.599 10 2.185L10 1C10 .448 9.553 0 9 0 8.447 0 8 .448 8 1L8 2.185C6.839 2.599 6 3.698 6 5 6 6.302 6.839 7.401 8 7.815L8 15C8 15.552 8.447 16 9 16 9.553 16 10 15.552 10 15L10 7.815C11.161 7.401 12 6.302 12 5M15 12C14.447 12 14 11.552 14 11 14 10.448 14.447 10 15 10 15.553 10 16 10.448 16 11 16 11.552 15.553 12 15 12M18 11C18 9.698 17.161 8.599 16 8.185L16 1C16 .448 15.553 0 15 0 14.447 0 14 .448 14 1L14 8.185C12.839 8.599 12 9.698 12 11 12 12.302 12.839 13.401 14 13.815L14 15C14 15.552 14.447 16 15 16 15.553 16 16 15.552 16 15L16 13.815C17.161 13.401 18 12.302 18 11",
  transform: "translate(2 3)"
});

var SvgSettings = function SvgSettings(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgSettings;